// src/Components/atoms/Icon/index.tsx
import React from "react";
import { cgIcons, faIcons, goIcons, luIcons, mdIcons } from "./registry";
import { StyledIcon } from "./styles";
import iconData from "./iconData.json";
import {
  CgIconNames,
  FaIconNames,
  GoIconNames,
  IconProps,
  LuIconNames,
  MdIconNames,
} from "./types";

// Mapa de tamanhos pré-definidos
const iconSizeMap = {
  extraSmall: 12,
  small: 16,
  medium: 24,
  large: 32,
  extraLarge: 48,
} as const;

export const Icon: React.FC<IconProps> = ({
  name,
  svgName,
  size = 24,
  color = "darkGray",
  library = "fa",
  label,
  onClick,
}) => {
  // Verifica se o tamanho é uma string e converte para número
  const resolvedSize =
    typeof size === "string" ? iconSizeMap[size] || 24 : size;

  const IconComponent =
    library === "fa"
      ? (faIcons[name as FaIconNames] as React.ElementType)
      : library === "md"
        ? (mdIcons[name as MdIconNames] as React.ElementType)
        : library === "cg"
          ? (cgIcons[name as CgIconNames] as React.ElementType)
          : library === "go"
            ? (goIcons[name as GoIconNames] as React.ElementType)
            : library === "lu"
              ? (luIcons[name as LuIconNames] as React.ElementType)
              : null;

  // Verifica se é um SVG path do iconData
  if (svgName && svgName in iconData) {
    return (
      <StyledIcon
        size={resolvedSize}
        color={color}
        role="img"
        aria-label={label || svgName}
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1024 1024"
          width={resolvedSize}
          height={resolvedSize}
          fill="currentColor"
        >
          <path d={iconData[svgName as keyof typeof iconData]} />
        </svg>
      </StyledIcon>
    );
  }

  // Verifica se é um ícone de biblioteca
  if (IconComponent) {
    return (
      <StyledIcon
        as={IconComponent}
        size={resolvedSize}
        color={color}
        role="img"
        aria-label={label || name}
        onClick={onClick}
      />
    );
  }

  console.warn(
    `O ícone ${name || svgName} não foi encontrado na biblioteca ${library}`,
  );
  return null;
};
